(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4800,1674,557,2948,4557,5823],{

/***/ 73276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop",
      function () {
        return __webpack_require__(19315);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseIconBlack = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.46584 8.00012L15.6959 1.76972C16.1014 1.36446 16.1014 0.709208 15.6959 0.303946C15.2907 -0.101315 14.6354 -0.101315 14.2302 0.303946L7.99991 6.53434L1.76983 0.303946C1.36438 -0.101315 0.709335 -0.101315 0.304082 0.303946C-0.101361 0.709208 -0.101361 1.36446 0.304082 1.76972L6.53416 8.00012L0.304082 14.2305C-0.101361 14.6358 -0.101361 15.291 0.304082 15.6963C0.506044 15.8984 0.771594 16 1.03695 16C1.30231 16 1.56767 15.8984 1.76983 15.6963L7.99991 9.46589L14.2302 15.6963C14.4323 15.8984 14.6977 16 14.963 16C15.2284 16 15.4938 15.8984 15.6959 15.6963C16.1014 15.291 16.1014 14.6358 15.6959 14.2305L9.46584 8.00012Z",
            fill: "black"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseIconBlack);


/***/ }),

/***/ 90042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CouponsAndVouchers_PromosDrawerAndButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(70758);
// EXTERNAL MODULE: ./src/assets/svgExports/CloseIconBlack.js
var CloseIconBlack = __webpack_require__(23483);
;// CONCATENATED MODULE: ./src/components/FloatingButtonAndDrawer/index.tsx






var FloatingButtonAndDrawer = function(param) {
    var buttonConfig = param.buttonConfig, showDrawer = param.showDrawer, onClose = param.onClose, drawerHeading = param.drawerHeading, additionalHeaderComponent = param.additionalHeaderComponent, children = param.children, showCloseIcon = param.showCloseIcon;
    var renderFloatingButton = function renderFloatingButton() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-fixed  tw-bottom-1/2 tw-right-0 tw-origin-bottom-right -tw-rotate-90 ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "tw-flex tw-cursor-pointer tw-items-center tw-gap-[4px] tw-border-none tw-px-[28px] tw-py-[8px] tw-text-[15px]/[20px] tw-font-bold tw-text-white md:tw-py-[12px]  ",
                style: {
                    backgroundColor: themeColor
                },
                onClick: onButtonClick,
                children: [
                    buttonConfig.icon || null,
                    " ",
                    buttonConfig.text
                ]
            })
        });
    };
    var renderDrawerHeader = function renderDrawerHeader() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-sticky tw-top-0 tw-z-50 tw-border-b tw-border-solid tw-border-[#E3E3E3] tw-bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-[12px] tw-px-[20px] tw-py-[32px] tw-text-[18px]/[20px] tw-font-semibold md:tw-px-[24px]",
                    children: [
                        (showCloseIcon !== null && showCloseIcon !== void 0 ? showCloseIcon : true) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-flex tw-cursor-pointer",
                            onClick: onCloseFinal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconBlack/* default */.Z, {
                                size: checkClientDeviceType/* IS_DESKTOP */.yn ? 16 : 12
                            })
                        }),
                        drawerHeading
                    ]
                }),
                additionalHeaderComponent
            ]
        });
    };
    var renderDrawerContent = function renderDrawerContent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex tw-flex-col",
            children: children
        });
    };
    var ref = (0,react.useState)(false), openDrawer = ref[0], setOpenDrawer = ref[1];
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var onCloseDrawer = function() {
        return setOpenDrawer(false);
    };
    var onOpenDrawer = function() {
        return setOpenDrawer(true);
    };
    var showFinal = showDrawer !== null && showDrawer !== void 0 ? showDrawer : openDrawer;
    var onCloseFinal = onClose !== null && onClose !== void 0 ? onClose : onCloseDrawer;
    var _onClick;
    var onButtonClick = (_onClick = buttonConfig.onClick) !== null && _onClick !== void 0 ? _onClick : onOpenDrawer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderFloatingButton(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                open: showFinal,
                onClose: onCloseFinal,
                classes: {
                    paper: checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-w-[40%] tw-min-w-[596px]" : "tw-h-full"
                },
                anchor: checkClientDeviceType/* IS_DESKTOP */.yn ? "right" : "bottom",
                transitionDuration: checkClientDeviceType/* IS_DESKTOP */.yn ? 300 : 400,
                children: [
                    renderDrawerHeader(),
                    renderDrawerContent()
                ]
            })
        ]
    });
};
/* harmony default export */ var components_FloatingButtonAndDrawer = (FloatingButtonAndDrawer);

// EXTERNAL MODULE: ./src/assets/svgExports/OfferIcon.js
var OfferIcon = __webpack_require__(93757);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/TabsContainer/index.tsx
var TabsContainer = __webpack_require__(1325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(68615);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/PromosContainer.tsx
var PromosContainer = __webpack_require__(69708);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/PromosSections/StoreOffersSection.tsx


var StoreOffersSection = function(param) {
    var storePromos = param.storePromos, onPromoClick = param.onPromoClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosContainer/* PromosContainer */.$, {
        promos: storePromos,
        onPromoClick: onPromoClick,
        customClasses: "tw-flex tw-flex-col md:tw-px-[24px] md:tw-py-[21px]",
        primaryTextClasses: "tw-text-[13px]/[18px] tw-font-medium md:tw-text-[16px]/[20px] md:tw-font-semibold",
        secondaryTextClasses: "tw-text-[12px]/[20px] tw-font-normal md:tw-text-[15px]/[20px]"
    });
};
/* harmony default export */ var PromosSections_StoreOffersSection = (StoreOffersSection);

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/BankOffers/index.tsx
var BankOffers = __webpack_require__(11110);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/PromosSections/BankOffersSection.tsx


var BankOffersSection = function(param) {
    var paymentOffersList = param.paymentOffersList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BankOffers/* default */.Z, {
        showAllPromos: true,
        paymentOffersList: paymentOffersList,
        isCartPage: false
    });
};
/* harmony default export */ var PromosSections_BankOffersSection = (BankOffersSection);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(82516);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/index.tsx











var PromosDrawerAndButton = function() {
    var getPromos = function getPromos() {
        var data = {
            storeId: storeId,
            userId: userId
        };
        dispatch((0,promo/* getAllPromos */.mv)(data, function(allPromos) {
            return dispatch((0,promo/* saveCouponsList */.Kp)({
                coupons: allPromos
            }));
        }));
        dispatch((0,promo/* getPaymentOffersList */.Xu)(storeId));
    };
    var openPromoModal = function openPromoModal(promoId) {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: true,
            promoId: promoId
        }));
        checkClientDeviceType/* IS_DESKTOP */.yn && setShowPromos(false);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return {
            storeId: state.storeReducer.store.store_id,
            userId: ((ref = state.userReducer.data) === null || ref === void 0 ? void 0 : ref.user_id) || 0,
            paymentOffersList: state.promoReducer.paymentOffersList || [],
            promos: state === null || state === void 0 ? void 0 : (ref1 = state.promoReducer) === null || ref1 === void 0 ? void 0 : ref1.couponsList
        };
    }), storeId = ref.storeId, userId = ref.userId, paymentOffersList = ref.paymentOffersList, promos = ref.promos;
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    var ref1 = (0,react.useState)(0), activeTabIndex = ref1[0], setActiveTabIndex = ref1[1];
    var ref2 = (0,react.useState)(false), showPromos = ref2[0], setShowPromos = ref2[1];
    var tabsData = [
        {
            text: "Store Offers"
        },
        {
            text: "Bank Offers"
        }, 
    ];
    (0,react.useEffect)(function() {
        if (storeId && !isCouponsFeatureLocked && !promos.length) {
            getPromos();
        }
    }, [
        storeId,
        isCouponsFeatureLocked
    ]);
    var showStoreOffers = activeTabIndex === 0;
    return !isCouponsFeatureLocked && !!promos.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FloatingButtonAndDrawer, {
            buttonConfig: {
                text: "Offers",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferIcon/* default */.Z, {}),
                onClick: function() {
                    return setShowPromos(true);
                }
            },
            showDrawer: showPromos,
            onClose: function() {
                return setShowPromos(false);
            },
            drawerHeading: "Offers",
            additionalHeaderComponent: !!(paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainer/* default */.Z, {
                activeTabIndex: activeTabIndex,
                setActiveTabIndex: setActiveTabIndex,
                tabsData: tabsData,
                tabClasses: "!tw-text-[14px]/[20px] md:!tw-text-[18px]/[20px] !tw-px-[20px] md:!tw-px-[32px] tw-pb-[18px]"
            }),
            children: showStoreOffers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosSections_StoreOffersSection, {
                storePromos: promos,
                onPromoClick: openPromoModal
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosSections_BankOffersSection, {
                paymentOffersList: paymentOffersList
            })
        })
    });
};
/* harmony default export */ var CouponsAndVouchers_PromosDrawerAndButton = (PromosDrawerAndButton);


/***/ }),

/***/ 15241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FullPageLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79220);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74151);



// import interLoader from '../../../public/assets/images/inter-loader.gif';


function FullPageLoader() {
    var ref, ref1;
    var ref2 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref2.widgetContextState.globalStyle;
    var globalLoader = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            globalLoader: state.commonReducer.globalLoader
        };
    }).globalLoader;
    return globalLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "global-loader",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__/* .GlobalCfeLoader */ .I, {
            type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.appLoader) === null || ref === void 0 ? void 0 : ref.loaderId) || "ellipsis",
            color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.color
        })
    });
}


/***/ }),

/***/ 557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_operatingSystem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55311);
/* harmony import */ var _useInstallAppOverlayActions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41771);




function InstallAppInstructionsOverlay() {
    var ref = (0,_useInstallAppOverlayActions__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), showInstallAppOverlay = ref.showInstallAppOverlay, closeIntallAppOverlay = ref.closeIntallAppOverlay;
    if (!showInstallAppOverlay) return;
    var os = (0,_utils_operatingSystem__WEBPACK_IMPORTED_MODULE_2__/* .getMobileOperatingSystem */ .HG)();
    var getScreenText = function() {
        var pageContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: "Feature not supported for the device type."
        });
        if (os === _utils_operatingSystem__WEBPACK_IMPORTED_MODULE_2__/* .OS_ENUMS.ios */ .wo.ios) {
            pageContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Click ("
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "tw-h-[20px] tw-w-[20px]",
                        alt: "share logo",
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/piNJGxx8.webp"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: ") then 'Add to Home screen' from browser menu to add your store app for easy access."
                    })
                ]
            });
        } else if (os === _utils_operatingSystem__WEBPACK_IMPORTED_MODULE_2__/* .OS_ENUMS.android */ .wo.android) {
            pageContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Click ("
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "tw-h-[20px] tw-w-[20px]",
                        alt: "3 dots logo",
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/tniWDkqL.webp"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: ") then 'Add to home screen'/'Install App' from browser menu to add your store app for easy access."
                    })
                ]
            });
        }
        return pageContent;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[999] tw-flex tw-flex-col tw-items-center tw-justify-start tw-bg-[#000000df]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "tw-m-0 tw-mb-2 tw-mt-48 tw-w-[70%] tw-text-left tw-text-white",
                children: "Add your store app"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-w-[70%] tw-text-left tw-text-white",
                children: getScreenText()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-mt-3 tw-flex tw-w-[60%] tw-justify-end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    onClick: function() {
                        closeIntallAppOverlay();
                    },
                    type: "button",
                    className: "tw-rounded-lg tw-bg-white tw-px-3 tw-py-2 tw-text-center tw-text-xs tw-font-medium tw-text-black hover:tw-opacity-70",
                    children: "Okay"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (InstallAppInstructionsOverlay);


/***/ }),

/***/ 32948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52388);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31024);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96031);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66162);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72651);
/* harmony import */ var _utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59186);









var VariantChooseRepeatModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        repeatIndex: null,
        theme: null
    }), state = ref14[0], setState = ref14[1];
    var ref15 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.commonReducer;
    }), chooseRepeatModal = ref15.variant.chooseRepeatModal, productLoaderId = ref15.productLoaderId;
    var cartData = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.cartReducer;
    });
    var ref16 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    }), theme = ref16.theme, store_id = ref16.store_id;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (chooseRepeatModal) {
            var productIndex = cartData.items.findIndex(function(el) {
                return el.id === productLoaderId;
            });
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                    repeatIndex: productIndex
                });
            });
        }
    }, [
        chooseRepeatModal,
        cartData,
        productLoaderId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (chooseRepeatModal) {
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                    theme: theme
                });
            });
        }
    }, [
        chooseRepeatModal,
        theme
    ]);
    var onClose = function() {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .setChooseAndRepeatModalVisibility */ .uT)(false));
    };
    var onIWillChooseBtnHandle = function() {
        /** get the details item for this item id */ dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .fetchCatalogItemById */ .eP)({
            store_id: store_id,
            item_id: productLoaderId,
            src: "variant_choose_repeat_modal"
        }, true));
        onClose();
    };
    var onRepeatBtnHandle = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var newCart = (0,_utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__/* .mutateVariantItemWithCartData */ .I)("repeat", cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[state.repeatIndex], cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[state.repeatIndex]) === null || ref2 === void 0 ? void 0 : ref2.variants_selected[(cartData === null || cartData === void 0 ? void 0 : (ref3 = cartData.items) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[state.repeatIndex]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.variants_selected) === null || ref5 === void 0 ? void 0 : ref5.length) - 1], cartData);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .saveCart */ .FP)(newCart));
        onClose();
    };
    return chooseRepeatModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        visible: chooseRepeatModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0
        },
        height: "auto",
        animation: "slideUp",
        className: "bottom-modal variantChooseRepeatModal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "closeicon",
                onClick: onClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    loading: "lazy",
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "title",
                children: "Choose a Variant"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sub-title",
                children: "Your Last Choice"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                className: "variant-name",
                children: (ref5 = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[state.repeatIndex]) === null || ref1 === void 0 ? void 0 : ref1.variants_selected[(cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[state.repeatIndex]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variants_selected) === null || ref4 === void 0 ? void 0 : ref4.length) - 1]) === null || ref5 === void 0 ? void 0 : ref5.variant_name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "choose_btn pointer",
                        style: {
                            borderRadius: "".concat(state.theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__/* .roundnessCalculator */ .M)((ref6 = state.theme) === null || ref6 === void 0 ? void 0 : ref6.roundness)) : "8px"),
                            borderColor: "".concat(state.theme ? (ref7 = state.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color : "#EA5151"),
                            color: "".concat(state.theme ? (ref9 = state.theme) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.colors) === null || ref10 === void 0 ? void 0 : ref10.primary_color : "#EA5151")
                        },
                        onClick: onIWillChooseBtnHandle,
                        children: "I’LL CHOOSE"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "repeat_btn pointer",
                        style: {
                            backgroundColor: "".concat(state.theme ? (ref11 = state.theme) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.colors) === null || ref12 === void 0 ? void 0 : ref12.primary_color : "#EA5151"),
                            borderRadius: "".concat(state.theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__/* .roundnessCalculator */ .M)((ref13 = state.theme) === null || ref13 === void 0 ? void 0 : ref13.roundness)) : "8px"),
                            color: "#ffffff"
                        },
                        onClick: onRepeatBtnHandle,
                        children: "REPEAT"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VariantChooseRepeatModal);


/***/ }),

/***/ 84557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_VariantSelectedListModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(67936);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(66162);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(72651);
;// CONCATENATED MODULE: ./src/components/Common/IncDecButton/index.js
/**
 * Increament Decreament Button for Catalog Items
 */ 

var IncDecButton = function(param) {
    var quantity = param.quantity, onChangeEventhandle = param.onChangeEventhandle, _showAddAction = param.showAddAction, showAddAction = _showAddAction === void 0 ? -1 : _showAddAction, catalogCta = param.catalogCta, showLoader = param.showLoader, _disableAddition = param.disableAddition, disableAddition = _disableAddition === void 0 ? false : _disableAddition;
    var styleClass = catalogCta ? "addtocart" : "pdp-addtocart";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(styleClass, "-btn"),
        style: !catalogCta ? {
            backgroundColor: "".concat(quantity <= 0 ? "#EA5151" : "#ffffff")
        } : {
            backgroundColor: "#ffffff"
        },
        children: [
            showAddAction < 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(styleClass, "-btn__changeIcon"),
                onClick: function() {
                    return onChangeEventhandle("add");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "ADD",
                            !catalogCta && "+"
                        ]
                    }),
                    catalogCta && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        loading: "lazy",
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/P6ghQCtu.webp",
                        alt: "Add Item button"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__changeIcon"),
                        onClick: function() {
                            return onChangeEventhandle("dec");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            loading: "lazy",
                            src: "https://cdn.dotpe.in/longtail/themes/8073865/GPgsbV9o.webp",
                            alt: "Decreament button"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__text"),
                        children: quantity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__changeIcon"),
                        onClick: function() {
                            return onChangeEventhandle("inc");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "din ".concat(disableAddition ? "o-20" : "o-100"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/P6ghQCtu.webp",
                                alt: "Increment button"
                            })
                        })
                    })
                ]
            }),
            showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-wrapper"
            })
        ]
    });
};
/* harmony default export */ var Common_IncDecButton = (IncDecButton);

// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(86812);
// EXTERNAL MODULE: ./src/utils/itemQuantityValueComparison.js
var itemQuantityValueComparison = __webpack_require__(73175);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/mutateVariantItemWithCartData.js
var mutateVariantItemWithCartData = __webpack_require__(59186);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(44779);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(91240);
;// CONCATENATED MODULE: ./src/components/VariantSelectedListModal/index.js

















var VariantSelectedListModal = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,useCartHandler/* useCartHandlers */.u)(), handleIncreamentClick = ref3.handleIncreamentClick, handleDecreamentClick = ref3.handleDecreamentClick, handleSetProductData = ref3.handleSetProductData;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)({
        itemCartIndex: null
    }), state = ref4[0], setState = ref4[1];
    var ref5 = (0,es/* useSelector */.v9)(function(state) {
        return state.commonReducer;
    }), selectedVariantsModal = ref5.variant.selectedVariantsModal, productLoaderId = ref5.productLoaderId;
    var ref6 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            storeData: state.storeReducer.store,
            cartData: state.cartReducer,
            pdpData: state.catalogReducer.pdpData
        };
    }), userData = ref6.userData, storeData = ref6.storeData, cartData = ref6.cartData, pdpData = ref6.pdpData;
    (0,react.useEffect)(function() {
        if (selectedVariantsModal) {
            var ref;
            var productIndex = cartData.items.findIndex(function(el) {
                return el.item_id === productLoaderId;
            });
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    itemCartIndex: productIndex
                });
            });
            if (productLoaderId) {
                dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                    store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                    item_id: productLoaderId,
                    src: "variant_selected_modal"
                }, false, function(data) {
                    handleSetProductData(data);
                    dispatch((0,catalog/* savePDPData */.zP)(data));
                }));
            }
            if (cartData && !(cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[productIndex])) {
                onClose();
            }
        }
    }, [
        selectedVariantsModal,
        cartData,
        productLoaderId
    ]);
    (0,react.useEffect)(function() {
        if (selectedVariantsModal) {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            }
        } else {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "scroll";
            }
        }
    }, [
        selectedVariantsModal
    ]);
    var onClose = function() {
        dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(false));
    };
    var handleAddRemoveItem = function(type, variantType) {
        var ref, ref1, ref2;
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                domain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
        var newCart = (0,mutateVariantItemWithCartData/* mutateVariantItemWithCartData */.I)(type, cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : ref2[state.itemCartIndex], variantType, cartData);
        dispatch((0,cart/* saveCart */.FP)(newCart));
    };
    var handleOnChange = function(type, variant) {
        if (pdpData === null || pdpData === void 0 ? void 0 : pdpData.product_personalization) {
            handleSetProductData(pdpData);
            checkRenderEnv/* IS_CLIENT */.kc && LocalStorageHelper/* default.add */.Z.add("activeVariantId", variant === null || variant === void 0 ? void 0 : variant.variant_id);
            if (type === "inc") {
                handleIncreamentClick(type, pdpData);
            } else if (type === "dec") {
                handleDecreamentClick(type, pdpData);
            }
            dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(false));
        } else {
            handleAddRemoveItem(type, variant);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: selectedVariantsModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0
        },
        height: "auto",
        animation: "slideUp",
        className: "bottom-modalVvariantSelectedListModal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "closeicon pointer",
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    loading: "lazy",
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "title",
                children: "Choose Item to remove"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "item-list",
                children: cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[state.itemCartIndex]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.map(function(variant, ind) {
                    var ref, ref1, ref2, ref3;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start justify-start",
                                children: [
                                    variant.images && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: variant === null || variant === void 0 ? void 0 : (ref = variant.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image_url,
                                        className: "img h3",
                                        alt: "variant image ".concat(ind + 1)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                        className: "left ml2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "item-name",
                                                children: cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[state.itemCartIndex]) === null || ref3 === void 0 ? void 0 : ref3.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "variant-name",
                                                children: variant.variant_name
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                className: "right",
                                style: {
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_IncDecButton, {
                                    disableAddition: (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(variant),
                                    catalogCta: true,
                                    showAddAction: 1,
                                    quantity: variant.quantity,
                                    onChangeEventhandle: function(change) {
                                        return handleOnChange(change, variant);
                                    }
                                })
                            })
                        ]
                    }, "items-variant-".concat(ind));
                })
            })
        ]
    });
};
/* harmony default export */ var components_VariantSelectedListModal = (VariantSelectedListModal);


/***/ }),

/***/ 78383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _utils_themeImports__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53978);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(66162);
/* harmony import */ var _components_VariantModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40261);
/* harmony import */ var _components_VariantChooseRepeatModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32948);
/* harmony import */ var _components_VariantSelectedListModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84557);
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66871);
/* harmony import */ var _utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98616);
/* harmony import */ var _components_DesignSystem_QuickViewModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(75684);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13886);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26706);
/* harmony import */ var _components_InstallAppInstructionsOverlay__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(557);
/* harmony import */ var _components_ProductCustomizationPopUp__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24648);
/* harmony import */ var _components_FullPageLoader_FullPageLoader__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15241);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6337);
/* harmony import */ var src_components_CouponsAndVouchers_PromosDrawerAndButton__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90042);




















// import useSetCart from '@/utils/customHooks';
var Shop = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    // const { triggerSetCart } = useSetCart();
    var storeData = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_11__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref9 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref;
        return {
            cart: state.cartReducer,
            personalizedProduct: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.personalizedProduct
        };
    }), cart = ref9.cart, personalizedProduct = ref9.personalizedProduct;
    var isB2bStore = (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_7__/* .getStoreType */ .K)(storeData) === _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .STORE_CUSTOMIZATION.B2B */ .DO.B2B;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var urlParams = new URLSearchParams(window.location.search);
        var utmSource = urlParams.get("utm_source");
        if (!_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_15__/* .IS_SERVER */ .W6 && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("utm_source")) !== utmSource) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("utm_source", utmSource);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (cart.items && cart.items.length > 0) {
            setCartAsyncCall();
        }
    }, [
        cart.pay_amount
    ]);
    var setCartAsyncCall = function() {
        return new Promise(function(resolve, reject) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_17__/* .setCart */ .RV)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, cart), {
                order_type: isB2bStore ? _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .ORDER_TYPE.B2B */ .Jm.B2B : cart.order_type,
                order_mode: isB2bStore ? 3 : cart.order_mode,
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                user_phone: cart.phone,
                cart_id: cart.cart_id
            }), function(status) {
                resolve();
            }));
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FullPageLoader_FullPageLoader__WEBPACK_IMPORTED_MODULE_14__/* .FullPageLoader */ .B, {}),
            (ref = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_8__/* .specificThemeRender */ .t)(storeData)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_3__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, layout);
            }),
            (ref3 = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_8__/* .specificThemeRender */ .t)(storeData)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.PLP) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_3__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                    showATCBtn: true,
                    shopPageBoolean: true
                }, layout));
            }),
            (ref6 = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_8__/* .specificThemeRender */ .t)(storeData)) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.components) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.Footer) === null || ref8 === void 0 ? void 0 : ref8.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_3__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VariantModal__WEBPACK_IMPORTED_MODULE_4__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VariantChooseRepeatModal__WEBPACK_IMPORTED_MODULE_5__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_VariantSelectedListModal__WEBPACK_IMPORTED_MODULE_6__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_DesignSystem_QuickViewModal__WEBPACK_IMPORTED_MODULE_9__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_InstallAppInstructionsOverlay__WEBPACK_IMPORTED_MODULE_12__["default"], {}),
            (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductCustomizationPopUp__WEBPACK_IMPORTED_MODULE_13__/* .ProductCustomizationPopUp */ .X, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_CouponsAndVouchers_PromosDrawerAndButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Shop);


/***/ }),

/***/ 19315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55847);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25291);
/* harmony import */ var _containers_Shop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78383);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68037);








var ShopPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        store: storeInfo,
        title: "".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name).concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.address) === null || ref1 === void 0 ? void 0 : ref1.city) ? Boolean((storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.address) === null || ref2 === void 0 ? void 0 : ref2.visibility) === 1) ? ", ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.address) === null || ref3 === void 0 ? void 0 : ref3.city) : "" : "", " - Order Online"),
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.store_info) === null || ref4 === void 0 ? void 0 : ref4.logo_image,
        metaDescription: storeInfo && (0,_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_7__/* .getMetaDescription */ .w)(storeInfo),
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.store_info) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
        isCustomDomain: props.isCustomDomain
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Shop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props))
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ShopPage);


/***/ }),

/***/ 55847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getMetaDescription; }
/* harmony export */ });
/**
 * @param {object} storeInfo
 * @param {object} seoDetails
 * @return {string}
 */ var getMetaDescription = function(storeInfo) {
    var seoDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref;
    if (!storeInfo) return "";
    if (seoDetails) return seoDetails.description;
    var description = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.default_seo) === null || ref === void 0 ? void 0 : ref.meta_description;
    return description || "";
// const businessTypes = storeInfo.store_businesses;
// const isAddresVisible = storeInfo?.address?.visibility === 1 ? true : false;
// let match = 13;
// let description = '';
// // default
// if (businessTypes && businessTypes.length > 1) {
//   match = 11;
// } else if (
//   businessTypes &&
//   businessTypes.length === 1 &&
//   businessTypes[0].business_id === 8
// ) {
//   match = 11;
// } else if (businessTypes && businessTypes.length === 0) {
//   match = 11;
// }
// // Genral store
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 1)
//   match = 1;
// // Pharmacy & Wellness
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 2)
//   match = 2;
// // Mobile & Electronics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 3)
//   match = 3;
// // Clothing & Fashion
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 4)
//   match = 4;
// // Resturants, Food Joints & Bakery
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 5)
//   match = 5;
// // Stationary & Office Supplies
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 6)
//   match = 6;
// // Arts, Jewellery & Collections
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 7)
//   match = 7;
// // Fruits & Vegetables
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 13)
//   match = 8;
// // Furniture & Home Decor
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 14)
//   match = 9;
// // Beauty & Cosmetics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 15)
//   match = 10;
// // real estate
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 16)
//   match = 12;
// switch (match) {
//   case 1:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Grocery & Dairy Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 2:
//     description = `Buy and Order online from  ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Pharmacy & Wellness Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 3:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Mobile & Electronics Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 4:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fashion Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 5:
//     description = `Order Food online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }|  Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     } . Order Now!`;
//     break;
//   case 6:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Stationary Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 7:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Arts, Jewellery & Collections Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 8:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fruits & Vegetables Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 9:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Furniture & Home Decor Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 10:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Beauty & Cosmetics Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 11:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 12:
//     description = `Buy / Sell / Rent your real estate dream property from ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     } | Real Estate Property ${storeInfo.store_info?.name}. Explore Now!`;
//     break;
//   default:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
// }
// return description;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6956,8388,1562,5843,6379,4814,7856,9228,6576,4429,8487,1033,5291,3978,537,6825,1242,8557,2031,3973,7909,4556,1868,4640,6235,2265,5684,9774,2888,179], function() { return __webpack_exec__(73276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);